import * as React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import {
    Badge,
    Card,
    OverlayTrigger,
    Tooltip,
    Collapse,
    Button,
} from 'react-bootstrap';

const CampaignCard = ({ campaign, language, t }) => {
    const [hovered, setHovered] = useState(false);
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const [show, setShow] = useState(false);

    return (
        <>
            <Card
                key={campaign._id}
                bg='light'
                text='dark'
                className='mb-sm-4 position-relative'
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-7px',
                        transform: `${
                            hovered ? 'scale(1.5,1.5)' : 'scale(1,1)'
                        }`,
                    }}
                >
                    <OverlayTrigger
                        placement='right'
                        overlay={
                            <Tooltip key='right' id={`tooltip-right`}>
                                {t('card_edit')}
                            </Tooltip>
                        }
                    >
                        <i
                            className='fas fa-edit fa-lg'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={(e) => {
                                e.preventDefault();
                                history.push(`/campaigns/${campaign._id}`);
                            }}
                        />
                    </OverlayTrigger>
                </div>
                <div className={`card-header ${campaign.isEnabled ? 'card-active' : 'card-inactive'}`} style={{backgroundColor: 'white !important'}} onClick={() => setOpen(!open)}>
                    <Card.Title className='text-center'>
                        {campaign.name}
                    </Card.Title>
                    <Card.Subtitle className='text-center text-white'>
                        <div>
                            {campaign.validFrom} - {campaign.validTo}
                        </div>
                    </Card.Subtitle>
                </div>
                <Card.Body className='p-0'>
                    <div className='pl-4 pr-4 pt-4'>
                        <span style={{ fontWeight: 'bold' }}>{t('card_description')}: </span>
                        {campaign.description}
                    </div>
                    <div>
                        <Collapse in={show}>
                            <div
                                id='collapsable-period-menu'
                                className='pl-4 pr-4'
                            >
                                <div className='d-flex mt-2 pb-0 mb-0'>
                                    {campaign.startingSignal ? (
                                        <>
                                            <div className='font-weight-bold'>
                                                {t('campaign_starting_signal')}:
                                            </div>
                                            <div className='ml-2'>
                                                {campaign.startingSignal.name}
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='d-flex mt-2 pb-0 mb-0'>
                                    {campaign.endingSignal ? (
                                        <>
                                            <div className='font-weight-bold'>
                                                {t('campaign_ending_signal')}:
                                            </div>
                                            <div className='ml-2'>
                                                {campaign.endingSignal.name}
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='d-flex mt-2 pb-0 mb-0'>
                                    {campaign.commercials.length > 0 ? (
                                        <>
                                            <div className='font-weight-bold'>
                                                {t('campaign_commercials')}:
                                            </div>
                                            <div className='ml-2'>
                                                {campaign.commercials.map(
                                                    (commercial) => (
                                                        <div>
                                                            {commercial.name}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                                <div className='d-flex mt-2 pb-0 mb-0'>
                                    {campaign.announcements.length > 0 ? (
                                        <>
                                            <div className='font-weight-bold'>
                                                {t('campaign_announcements')}:
                                            </div>
                                            <div className='ml-2'>
                                                {campaign.announcements.map(
                                                    (announcement) => (
                                                        <div>
                                                            {announcement.name}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </Collapse>
                    </div>
                    <div className='d-flex align-baseline mt-2 pb-0 mb-0'>
                        <Button
                            onClick={() => setShow(!show)}
                            className='m-auto'
                            size='sm'
                            block
                            variant='light'
                        >
                            {' '}
                            {show ? (
                                <i className='fas fa-angle-double-up fa-lg'></i>
                            ) : (
                                <i className='fas fa-angle-double-down fa-lg'></i>
                            )}
                        </Button>
                    </div>
                </Card.Body>
                <Card.Footer className='pl-2 pr-2 pt-3'>
                    {campaign.tags.map((tag) => (
                        <Badge
                            key={tag._id}
                            pill
                            variant='dark'
                            className='p-2 mb-1 mr-1'
                        >
                            {tag.name}
                        </Badge>
                    ))}
                </Card.Footer>
            </Card>
        </>
    );
};

export default CampaignCard;
